import React from 'react';
import { Typography } from '@ms/medsol-components';
import { formatPhoneNumberFromString } from '../../utilities/app-utilities';

export const TravelerPhone = React.memo(({ phone = '' }: { phone: string }) => (
    <Typography variant="p2" color="Gray_500">
        {formatPhoneNumberFromString(phone)}
    </Typography>
));
